// The theme switch in the signed-in chrome: moon | sun.
//
// NOT IN packs/, for the reason mock_composer.js records; imported by
// packs/application.js beside sidebar_toggle.js, whose shape this is.
//
// The switch is two real <form>s (button_to, PATCH /settings/theme), so it
// works with this pack absent: the page round-trips and comes back in the
// chosen theme, because the layout renders the profile's choice on <html>.
// This module is the enhancement on top: it intercepts the submit, flips
// `data-bs-theme` on <html> at once so nothing waits on the network, marks
// the chosen cell pressed, and sends the same form body by fetch.
//
// Three things about it are easy to undo by accident:
//
// - THE VALUE COMES OFF THE FORM. `data-theme-choice` is written by the
//   partial from Theme::DARK / Theme::LIGHT; nothing here types "dark" or
//   "light", so the module cannot disagree with the one declaration.
// - THE FLIP HOLDS WHEN THE SAVE FAILS. A student on a bad connection still
//   gets the theme for this visit, which is most of what they wanted; the
//   next page load reads whatever the server actually kept.
// - `theme-transition` IS ON <html> ONLY WHILE THE FLIP RUNS. application.scss
//   cross-fades the ground and the chrome under that class and nothing else;
//   leaving it on would animate every navigation's first paint.

const TRANSITION_MS = 250;

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.getAttribute("content") : "";
}

function apply(theme, forms) {
  const root = document.documentElement;
  root.classList.add("theme-transition");
  root.setAttribute("data-bs-theme", theme);
  window.setTimeout(() => root.classList.remove("theme-transition"), TRANSITION_MS);

  forms.forEach((form) => {
    const button = form.querySelector("[aria-pressed]");
    if (button) button.setAttribute("aria-pressed", String(form.dataset.themeChoice === theme));
  });
}

function save(form) {
  return fetch(form.action, {
    method: "POST", // the form's own _method field makes Rails route it as PATCH
    body: new FormData(form),
    headers: { "X-CSRF-Token": csrfToken(), "X-Requested-With": "XMLHttpRequest" },
    credentials: "same-origin",
  }).catch(() => {
    // Nothing to do and nothing to tell them: the page already flipped.
  });
}

function setup() {
  const forms = Array.from(document.querySelectorAll("form[data-theme-choice]"));
  if (forms.length === 0) return;

  forms.forEach((form) => {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      apply(form.dataset.themeChoice, forms);
      save(form);
    });
  });
}

// The same guard every module in this pack carries — see mock_request_wizard.js.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setup);
} else {
  setup();
}
